import { render } from "./ProfileSidebar.vue?vue&type=template&id=73ccd775&scoped=true&lang=pug"
import script from "./ProfileSidebar.vue?vue&type=script&lang=js"
export * from "./ProfileSidebar.vue?vue&type=script&lang=js"

import "./ProfileSidebar.vue?vue&type=style&index=0&id=73ccd775&lang=scss&scoped=true"

import exportComponent from "/Users/aladdin/Documents/Petar/fairwey-web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-73ccd775"]])

export default __exports__